// 用户存和快递存，选择方法
<template>
  <div class="mailSelectWay">
    <!-- 流程 -->
    <userSaveFlow v-if="oType === 'userSave'"></userSaveFlow>
    <userFetchFlow v-if="oType === 'userFetch'"></userFetchFlow>
    <userFastSaveFlow v-if="oType === 'userFastSave'"></userFastSaveFlow>

    <div class="way-list clearfix">
      <div class="list clearfix">
        <p class="title">打开微信扫二维码</p>
        <div class="detail">
          <div class="left-bracket"></div>
          <div class="code">
            <span
              class="text"
              v-show="QRurl === ''">二维码获取中...</span>
            <img
              :src="QRurl"
              v-show="QRurl !== ''" />
          </div>
          <div class="right-bracket"></div>
        </div>
      </div>
    </div>
    <!-- mqtt -->
    <mqttws ref="mqttws" @getMessage="getMessage"></mqttws> 
    <!-- 底部按钮 -->
    <btnCancel></btnCancel>
  </div>
</template>

<script>

// 组件
import mqttws from '../../../assets/mqttws2'
import btnCancel from '../common/btnCancel.vue'
import userSaveFlow from '../userSave/userSaveFlow'
import userFetchFlow from '../userFetch/userFetchFlow'
import userFastSaveFlow from '../userFastSave/userFastSaveFlow'

// js
import {
  showToast,
  showLoading,
  hideLoading,
  getWeiXinQRcode,
} from '../../../../static/mailBox/js/request.js'
import { storage } from '../../../../static/js/utils/utility.js'

export default {
  name: 'selectWay',

  components: {
    mqttws,
    btnCancel,
    userSaveFlow,
    userFetchFlow,
    userFastSaveFlow
  },

  data () {
    return {
      cardNum: '',
      QRurl: '',
      authID: '',
      oType: ''
    }
  },

  created () {
    this.oType = this.$route.query.oType
    // this.$store.state.mail_oType = this.oType // 用户选择的业务类型
    this.$store.commit('mail_oType', this.oType)
    console.log('用户选择的业务类型：', this.$store.state.mail_oType)
    console.log('用户的身份：', this.$store.state.mail_type)
    this.getWeiXinQRcode()
  },

  mounted () {
    // console.log(storage.localGetItem('device_no_id'))
  },

  watch: {

  },

  methods: {

    // 获取小程序二维码
    getWeiXinQRcode: async function () {
      let vm = this
      let data = {
        mode: 'getUnlimited',
        type: 'zy',
        data: {
          page: 'pages/login/login',
          scene: vm.$store.state.company_ic + 'zy' + storage.localGetItem('device_no_id')
        },
        device_no_id: storage.localGetItem('device_no_id')
      }
      let res = await getWeiXinQRcode(data)
      console.info('获取小程序二维码，res：', res)
      if (res.meta.code === 200) {
        vm.QRurl = res.data.image_url
      } else {
        showToast('二维码获取失败')
      }
    },

    // 获取mqtt信息
    getMessage(res) {
      // alert(res)
      let vm = this
      console.log('mqtt返回信息：', res)
      // type信息类型：identityCheck为身份认证， exp为扫描快递单号
      if (res.type === 'identityCheck') {
        if (res.meta.code === 200) {
          // 获取保存apitoken、存件者身份
          // vm.$store.state.apitoken = res.data.apitoken
          vm.$store.commit('apitoken', res.data.apitoken)
          // 保存用户id、身份类型和手机号码
          // let phoneNo = res.data.phone
          // vm.$store.state.mail_sendWay = res.data.way
          // vm.$store.state.mail_senderId = res.data.user_id
          // vm.$store.state.mail_type = res.data.user_type === 'admin' ? 'staff' : 'express'
          vm.$store.commit('mail_sendWay', res.data.way)
          vm.$store.commit('mail_senderId', res.data.user_id)
          vm.$store.commit('mail_type', res.data.user_type === 'admin' ? 'staff' : 'express')
          // 假设是快递员身份
          // vm.$store.state.mail_type = 'express'
          // vm.$store.commit('mail_type', 'express')
          console.info('mqtt返回信息的用户身份类型：', vm.$store.state.mail_type)
          // 模拟身份认证通过，跳转下一个页面
          if(vm.$store.state.mail_oType === 'userSave') {
            vm.goSelectConsignee()
          } else if (vm.$store.state.mail_oType === 'userFastSave') {
            vm.goScanExpressCode()
          } else if (vm.$store.state.mail_oType === 'userFetch') {
            vm.pickup()
          }
        } else {
          showToast(res.meta.message)
        }
      }
    },

    // 普通存件：跳转到选择取件人/输入手机号页面
    goSelectConsignee: function () {
      let vm = this
      vm.$router.push({
        // 你要跳转的地址
        path: '/mailBox/userSave/selectConsignee',
      })
    },

    // 快速存件：直接跳到扫描快递条形码步骤
    goScanExpressCode: function () {
      let vm = this
      vm.$router.push({
        path: '/mailBox/userSave/scanExpressCode',
      })
    },

    // 取件
    pickup: function () {
      let vm = this
      vm.$router.push({
        path: '/mailBox/userFetch/openBoxOne',
      })
    },
  }
}
</script>

<style lang='less' scoped>
.mailSelectWay {
  width: 100%;
  .way-list{
    width: 15.27rem;
    margin: 1.15rem auto 0;
  }

  .way-list .list{
    width: 6.14rem;
    text-align: center;
    margin: 0 auto;
  }

 .way-list .list .title{
    font-size: 0.45rem;
    font-weight: bold;
    line-height: 0.5rem;
    margin-bottom: 0.4rem;
  }

 .way-list .list .detail{
    width: 100%;
    height: 4.85rem;
  }

 .way-list .list .detail .left-bracket,
 .way-list .list .detail .right-bracket{
    float: left;
    width: 0.54rem;
    height: inherit;
    border: 0.04rem solid #ffffff;
  }

 .way-list .list .detail .left-bracket{
    border-right: none;
  }

 .way-list .list .detail .right-bracket{
    border-left: none;
  }

 .way-list .list .detail .card,
 .way-list .list .detail .code{
    float: left;
    height: 3.52rem;
    line-height: 3.52rem;
    font-size: 0.4rem;
  }

 .way-list .list .detail .card{
    width: 5.75rem;
    margin: 0.66rem 0.415rem 0;
    background-color: #efefef;
  }

 .way-list .list .detail .code{
    width: 3.52rem;
    font-size: 0.34rem;
    margin: 0.66rem 0.77rem 0;
  }

 .way-list .list .detail .code img{
    display: block;
    width: 3.52rem;
    height: 3.52rem;
    position: relative;
    z-index: 9999;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/mailBox/common/selectWay.vue